import { render, staticRenderFns } from "./NonLoginSharingProfile.vue?vue&type=template&id=f87cc420&scoped=true"
import script from "./NonLoginSharingProfile.vue?vue&type=script&lang=ts"
export * from "./NonLoginSharingProfile.vue?vue&type=script&lang=ts"
import style0 from "./NonLoginSharingProfile.vue?vue&type=style&index=0&id=f87cc420&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87cc420",
  null
  
)

export default component.exports